import AppCollection from "components/AppCollection"
import Loader from "components/Loader"
import PageHeader from "components/PageHeader"
import * as gamesAPI from "modules/gamesAPI"
import { useParams } from "react-router-dom"
import { useAsync } from "react-use"

export function AppCollectionPage() {
  const { appCollectionId } = useParams()

  const {
    value: appCollection,
    loading,
    error,
  } = useAsync(
    async () => await gamesAPI.getAppFeed(appCollectionId),
    [appCollectionId]
  )

  if (loading) return <Loader />
  if (error) throw error
  else if (!appCollection) throw new Error("Unknown App Feed Requested")

  const { id, title, apps } = appCollection
  return (
    <>
      <PageHeader titleSmall={title} backBtn settingsMenu />

      <div col={1} padding="top-sm bottom-xxl">
        <AppCollection
          key={id}
          id={id}
          apps={apps}
        />
      </div>
    </>
  )
}
